'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const NewMatterIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="NewMatterIcon">
      <svg width="79" height="79" viewBox="0 0 79 79" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2163_9998)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.7248 2.475C15.3056 0.892214 17.4503 0.00197382 19.6873 4.4859e-06H53.4373C53.8069 -0.000655592 54.173 0.0715359 54.5147 0.212452C54.8563 0.353368 55.1669 0.560244 55.4286 0.821254L77.9286 23.3213C78.1896 23.5829 78.3965 23.8935 78.5374 24.2351C78.6783 24.5768 78.7505 24.9429 78.7498 25.3125V70.3125C78.7498 71.4205 78.5316 72.5177 78.1076 73.5414C77.6835 74.5651 77.062 75.4952 76.2785 76.2787C75.495 77.0622 74.5649 77.6837 73.5412 78.1077C72.5175 78.5318 71.4203 78.75 70.3123 78.75H28.7154C29.2386 77.445 29.5311 76.0219 29.5311 74.5312V71.7188H32.3436C35.3272 71.7188 38.1887 70.5335 40.2985 68.4237C42.4083 66.3139 43.5936 63.4524 43.5936 60.4688C43.5936 57.4851 42.4083 54.6236 40.2985 52.5138C38.1887 50.404 35.3272 49.2188 32.3436 49.2188H29.5311V46.4063C29.5308 44.2869 28.9319 42.2107 27.8033 40.4168C26.6746 38.6229 25.0623 37.1843 23.1518 36.2667C21.2414 35.3491 19.1106 34.9899 17.0049 35.2303C14.8992 35.4707 12.9043 36.301 11.2498 37.6256V8.4375C11.2498 6.19875 12.1386 4.05 13.7248 2.475Z"
            fill="#D8DCE5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.2812 42.187C18.8353 42.187 19.3839 42.2961 19.8957 42.5081C20.4075 42.7202 20.8726 43.0309 21.2644 43.4227C21.6561 43.8144 21.9669 44.2795 22.1789 44.7913C22.3909 45.3032 22.5 45.8517 22.5 46.4058V56.2495H32.3437C33.4626 56.2495 34.5357 56.694 35.3269 57.4852C36.118 58.2763 36.5625 59.3494 36.5625 60.4683C36.5625 61.5871 36.118 62.6602 35.3269 63.4514C34.5357 64.2425 33.4626 64.687 32.3437 64.687H22.5V74.5308C22.5 75.6496 22.0555 76.7227 21.2644 77.5139C20.4732 78.305 19.4001 78.7495 18.2812 78.7495C17.1624 78.7495 16.0893 78.305 15.2981 77.5139C14.507 76.7227 14.0625 75.6496 14.0625 74.5308V64.687H4.21875C3.09987 64.687 2.02681 64.2425 1.23564 63.4514C0.444474 62.6602 0 61.5871 0 60.4683C0 59.3494 0.444474 58.2763 1.23564 57.4852C2.02681 56.694 3.09987 56.2495 4.21875 56.2495H14.0625V46.4058C14.0625 45.2869 14.507 44.2138 15.2981 43.4227C16.0893 42.6315 17.1624 42.187 18.2812 42.187Z"
            fill="#5073C3"
          />
        </g>
        <defs>
          <clipPath id="clip0_2163_9998">
            <rect width="78.75" height="78.75" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

NewMatterIcon.propTypes = {
  sx: PropTypes.object
}
